.card {
  background-color: var(--base-white);
  border: 1px solid var(--border-color-default);
  margin: var(--space-md) 0;
  padding: var(--space-md-lg);
  border-radius: var(--rounded-default);
  max-width: 40rem;

  h3 {
    font-size: var(--font-size-lg);
  }

  h4 {
    font-size: var(--font-size-md);
    font-weight: 700;
    margin-top: var(--space-md-lg);
    margin-bottom: var(--space-sm);

    /* Align the icon in a header */
    display: flex;
    gap: var(--space-sm);
    align-items: center;
  }

  a {
    color: var(--interactive-default);
    text-decoration: none;

    /* Align the icon in a link */
    display: flex;
    align-items: center;
    gap: var(--space-sm);
  }

  pre {
    font-family: var(--font-text), sans-serif;
    margin: 0;
    white-space: pre-wrap;
  }
}

.card_header {
  display: flex;
  gap: var(--space-md);
  align-items: center;

  a {
    margin-left: auto;
  }
}

.flex {
  display: flex;
}
